module.exports = __webpack_public_path__ + "static/media/L.ce235553.jpg";